import { createTheme } from '@material-ui/core/styles'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#F26522',
    },
    secondary: {
      main: '#0D0C0C',
    },
  },
})
